import { TYPES } from "../../../common/constants";

export const applyFilter = (key, data) => ({
  type: TYPES.SERVICE_REQUEST_FILTERS_ADD,
  payload: { key, data },
});

export const applyFilters = (filters) => ({
  type: TYPES.SERVICE_REQUEST_FILTERS_BULK_ADD,
  payload: filters,
})

export const removeFilter = (key) => ({
  type: TYPES.SERVICE_REQUEST_FILTERS_REMOVE,
  payload: { key },
});

export const clearFilters = () => ({
  type: TYPES.SERVICE_REQUEST_FILTERS_CLEAR,
});
